export const defaultSortedPlayers = (players) => {
  let result = []
  for (let i = 1; i <= players.length; i++) {
    result.push(players.find(p => p.rank === i))
  }
  return result
}

export const sortPlayersByChapterRanks = (players, sortingByChapterName) => {
  let sortedPlayers = JSON.parse(JSON.stringify(players)) // deep copy array

  sortedPlayers.sort((a, b) => {
    a = a.eventChapterRanks[sortingByChapterName]
    b = b.eventChapterRanks[sortingByChapterName]
    if (a != null && b != null) {
      if (a > b) {
        return 1
      } else if (a < b) {
        return -1
      } else {
        return 0
      }
    } else {
      if (a != null) {
        return -1
      } else if (b != null) {
        return 1
      } else {
        return 0
      }
    }
  })

  return(sortedPlayers)
}

export const getPageOfPlayers = (players, pageSize, pageNumber, backfillLastPage = true) => {
  if (players.length < pageSize) {
    return (players)
  }
  // this is usually coming in from a query param :)
  pageNumber = Number(pageNumber)

  const numberOfPages = getNumberOfPages(players, pageSize)

  const pagesOffset = pageNumber - 1
  const playersOffset = pagesOffset * pageSize

  let outputPage = players.slice(playersOffset, pageSize * pageNumber)

  if (backfillLastPage) {
    // for the final page, we backfill with enough previous players to make a full page
    if (pageNumber !== 1 && pageNumber === numberOfPages && outputPage.length < pageSize) {
      let previousPlayerIndex = playersOffset - 1
      while (outputPage.length < pageSize) {
        outputPage.unshift(players[previousPlayerIndex])
        previousPlayerIndex -= 1
      }
    }
  }

  return (outputPage)
}

// this is for the summary view. each page is specifically only made of players in one division
export const getPagesOfPlayersFromSameDivision = (divisions, pageSize, backfillLastPageOfDivision = true) => {
  let outputPagesOfSlugs = []
  let outputDivisionIdxByPage = []

  divisions.forEach((divisionSlugs, divisionIdx) => {
    let divisionFinished = false
    let currentPageWithinDivision = 1
    while (!divisionFinished) {
      let pageOfSlugs = getPageOfPlayers(divisionSlugs, pageSize, currentPageWithinDivision)
      outputPagesOfSlugs.push(pageOfSlugs)
      outputDivisionIdxByPage.push(divisionIdx)

      currentPageWithinDivision += 1
      // we got everyone in this division if the last player of the last page we inserted is the last player in the division
      divisionFinished = pageOfSlugs[pageOfSlugs.length - 1] === divisionSlugs[divisionSlugs.length - 1]
    }
  })

  return [outputPagesOfSlugs, outputDivisionIdxByPage]
}

// this is specifically super fancy logic ONLY for the large detailed board on OBS
export const getPagesOfDisplayedDivisions = (divisions, pageSize, minDisplayedDivSize = 3, backfillLastPage = true) => {
  const divisionSizes = divisions.map(div => div.length)
  const totalPlayers = divisionSizes.reduce((cumulative, divSize) => cumulative + divSize, 0);

  let handledPlayersCount = 0

  let outputDivisionStructure = []
  let currentPage = 1
  let currentOffset = 0
  let currentDivIdx = 0
  let currentDisplayedDivObject = {}
  let availableSlots = pageSize
  while (handledPlayersCount < totalPlayers) {
    // with this while loop, we'll manually iterate over the divisions. we need the granular control of a while loop 
    // because sometimes a division is split across 2 pages

    // we build a model of what the pages will look like using js objects indicating offset and count in each division
    // then use it to build the current page at the return statement

    // if we've run out of space on this page (or, this is the first iteration)
    if (outputDivisionStructure.length < currentPage) { 
      outputDivisionStructure.push([]) // add new page
      currentDisplayedDivObject = { divIdx: currentDivIdx, offset: 0, count: 0 }
    }
    
    let currentOutputPage = outputDivisionStructure[outputDivisionStructure.length - 1]
    const currentDivSize = divisionSizes[currentDivIdx]
    let remainingPlayersInDiv = currentDivSize - currentOffset
    // 1 to account for the extra row for division name
    if (remainingPlayersInDiv < availableSlots - 1) {
      currentDisplayedDivObject = { divIdx: currentDivIdx, offset: currentOffset, count: remainingPlayersInDiv }

      // "iterating to the next division" happens here
      currentDivIdx += 1
      currentOffset = 0
      availableSlots -= remainingPlayersInDiv
      handledPlayersCount += remainingPlayersInDiv

      // console.log({currentPage, currentDisplayedDivObject, availableSlots, handledPlayersCount})
    } else {
      // handle the minimum div size here

      let displayedPlayersInDivOnThisPage = availableSlots - 1
      currentDisplayedDivObject = { divIdx: currentDivIdx, offset: currentOffset, count: displayedPlayersInDivOnThisPage }
      currentOffset += displayedPlayersInDivOnThisPage

      availableSlots -= displayedPlayersInDivOnThisPage
      handledPlayersCount += displayedPlayersInDivOnThisPage
    }

    availableSlots -= 1 // no matter what, we're adding a header. that always takes up a slot

    currentOutputPage.push(currentDisplayedDivObject)

    if ((availableSlots - 1) < minDisplayedDivSize) {
      currentPage += 1
      availableSlots = pageSize
    }
  }

  const outputDivisions = (outputDivisionStructure.map((outputDivisionsPage) => 
    outputDivisionsPage.map(divObj => (
      divisions[divObj.divIdx].slice(divObj.offset, divObj.count + divObj.offset)
    ))
  ))

  const outputDivIdxByPage = outputDivisionStructure.map(outputDivisionsPage => (
    outputDivisionsPage[0].divIdx
  ))
  // debugger
  // console.log({outputDivisionStructure})
  return [outputDivisions, outputDivIdxByPage]
}

export const getNumberOfPages = (players, pageSize) => {
  if (!pageSize) return 0
  return Math.ceil(players.length / pageSize)
}

export const CHAPTER_NOT_STARTED = 'not_started'
export const CHAPTER_IN_PROGRESS = 'in_progress'
export const CHAPTER_COMPLETE = 'complete'

export const getSubscribedChannelNames = () => {
  if (window.consumer && window.consumer.subscriptions) {
    return window.consumer.subscriptions.subscriptions.map(sub => {
      return JSON.parse(sub.identifier).channel
    })
  }

  return []
}

export const trimMs = (timeStr, digits) => {
  if (!timeStr.includes('.')) {
    return timeStr
  }
  return (
    digits === 0
      ? `${timeStr.split('.')[0]}`
      : `${timeStr.split('.')[0]}.${timeStr.split('.')[1].slice(0,digits)}`
  )
}

export const getTimeSpacerStrings = (chapterNames, players) => {
  const timeSpacerStrings = Array(chapterNames.length).fill('')
  const keys = [...chapterNames, 'total']

  keys.forEach((chapterNameOrTotal, i) => {
    let maxLengthSoFar = 0
    players.forEach(player => {
      const bestTime = player.eventBestTimes[chapterNameOrTotal]
      const length = bestTime?.length || 0
      if (length > maxLengthSoFar) {
        maxLengthSoFar = length
        timeSpacerStrings[i] = bestTime
      }
    })

    timeSpacerStrings[i] = timeSpacerStrings[i]?.replace(/\d/g, '0') || ''
  })

  const chapterTimeSpacerStrings = timeSpacerStrings.slice(0, chapterNames.length)
  const totalTimeSpacerString = timeSpacerStrings[timeSpacerStrings.length - 1]

  return [chapterTimeSpacerStrings, totalTimeSpacerString]
}

export const getFormattedDelta = (delta, chapterName) => {
  let result
  const digitCount = delta.replace(/[^\d]/g, '').length

  // if a chapter name is provided, we have less room to show digits
  if (chapterName) {
    if (digitCount === 5) {
      // show -12.345 1A as -12.3 1A
      result = delta.slice(0, 5)
    } else if (digitCount >= 6) {
      // show -1:23.456 1A as -1:12 1A
      result = delta.split('.')[0]
    } else {
      // show -1.234 1A as -1.2 1A
      result = delta.slice(0, 4)
    }
  } else {
    if (digitCount === 5) {
      // show -12.345 as -12.3
      result = delta.slice(0, 5)
    } else if (digitCount >= 6) {
      // show -1:23.456 as -1:12
      result = delta.split('.')[0]
    } else {
      // show -1.234 as is, without truncating
      result = delta
    }
  }

  // this is &minus; aka U+2212 aka Minus Sign. looks nicer in our font for this purpose
  const betterMinusSign = '−'

  return result.replace('-', betterMinusSign)
}

// this whole block is only here to compute the title attribute of the "4/7 chapters" text
// that appears when a player has not finished all chapters in IL mode. this itself is only useful
// on the public app simple board page and submissions feed where users can hover the text
export const getChapterProgressTooltipText = (player, event, layoutSettings) => {
  if (!event.isIl || player.completedAllChapters) return null
  
  const shouldUseFullChapterNames = layoutSettings.obsPlayerPanelChapterNames === 'full'

  const completedChapterNames = player.completedChapterNames
  const completedChapterStrings = completedChapterNames.map(chapterName => (
    shouldUseFullChapterNames
      ? event.chapters[chapterName].fullName
      : event.chapters[chapterName].nameOverrides.columnHeader || chapterName.toUpperCase()
  ))

  const joinString = shouldUseFullChapterNames ? '\n' : ', '

  return completedChapterStrings.join(joinString)
}

export const createSettingsCookie = (settings) => {
  const settingsStr = `settings=${encodeURIComponent(JSON.stringify(settings))}` 
  
  const expiresInDays = 399 // max cookie lifetime is 400 days, closest there is no non expiring cookies
  const expirationDate = new Date()
  expirationDate.setTime(expirationDate.getTime() + expiresInDays * 24 * 60 * 60 * 1000)
  const expiresStr = `expires=${expirationDate.toUTCString()}`

  const pathStr = 'path=/'

  document.cookie = [settingsStr, expiresStr, pathStr].join('; ')
}

export const readSettingsCookie = () => {
  const settingsCookie = document.cookie.split(';').find(c => (
    c.startsWith('settings=') || c.startsWith(' settings=')
  ))

  let settings = {}
  if (settingsCookie) {
    try {
      const encodedSettings = settingsCookie.split('=')[1]
      settings = JSON.parse(decodeURIComponent(encodedSettings))
    } catch (error) {
      console.error('failed to parse settings cookie:', error.message)
    }
  }

  return settings
}

export const slugify = (str) => {
  return str.replace(/[^\w\d]/g, '').toLowerCase()
}

export const OBS_SCENE_CHANGED_EVENT = 'obsSceneChanged'

export const IL_MODE = 'il'
export const FULL_GAME_MODE = 'full_game'
export const BINGO_MODE = 'bingo'
